export default __webpack_public_path__ + "static/media/Group 3177@2x.3a62edb3.png";